
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import MachinesList1 from "./machineList";
import MachinesList3 from "./machineList3";
import ProdListBut from "./prodListButton";
import axios from "axios";
import { apiClient } from "../api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from 'date-fns/locale';
import { format } from "date-fns";
import ModelListBut from "./modelListButton";
import ShiftList2 from "./shiftList2";
import OperatorList2 from "./operatorList2";
import ChatReg1 from "./chatReg1";

const NewBatchForm = () => {
    const { t } = useContext(LanguageContext);
    const navigate = useNavigate();
    const handleGoBack = () => { navigate(-1); };

    const user = JSON.parse(localStorage.getItem("user"));
    const company = JSON.parse(localStorage.getItem("company"));


    const formatTime = (date) => {
        if (!date) return null;
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}:00`; // formato que MySQL espera
    };


    const [codMaq, setCodMaq] = useState("");
    const [idProd, setIdProd] = useState("");
    const [model, setModel] = useState("")
    const [nameProd, setNameProd] = useState("");
    const [descProd, setDescProd] = useState("");
    const [unidad, setUnidad] = useState("u");
    const [ciclosHora, setCiclosHora] = useState(0);
    const [undPorCiclo, setUndPorCiclo] = useState(0);

    const [loteCod, setBatch] = useState("");

    const [fechaIni, setfechaIni] = useState(null);
    const [timeIni, setTimeIni] = useState("");

    const [timeFin, setTimeFin] = useState("");
    const [undOK, setUndOK] = useState("");
    const [undNC, setUndNC] = useState("");

    const [idShift, setIdShift] = useState("");
    const [idOperator, setIdOperator] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const data = {
                id_c: company.id_c,
                cod_maq: codMaq,
                model: model,

                id_batch: loteCod,
                id_prod: idProd,
                id_shift: idShift,
                id_operator: idOperator,


                date_begin: format(fechaIni, "yyyy-MM-dd"),
                time_begin: formatTime(timeIni),

                time_end: formatTime(timeFin),
                cant_pt_ok: parseInt(undOK),
                cant_pt_nc: parseInt(undNC),
                id_user: parseInt(user.id_u)
            };

            //await axios.post("/products", data);
            await apiClient.post("/batches", data); // ✅ Esto usa la URL correcta dinámica


            alert("✅ Lote registrado exitosamente");
            handleGoBack();
        } catch (error) {
            console.error("❌ Error al registrar batch:", error);
            alert("Ocurrió un error al registrar el batch.");
        }
    };

    return (
        <div className="box1">
            <div className="box9">
                <form onSubmit={handleSubmit}>
                    <table className="form1">
                        <tbody>

                            <tr>
                                <td><label htmlFor="lote_code">{t("batchList12")}</label></td>
                                <td>
                                    <input
                                        className="input1"
                                        type="text"
                                        value={loteCod}
                                        onChange={(e) => setBatch(e.target.value)}
                                        id="lote_code"
                                        name="lote_code"
                                        required
                                    />
                                </td>
                            </tr>

              {/* 👇 NUEVO: Turno */}
              <tr>
                <td><label>{t("shifts1") || "Turno (id_shift)"}</label></td>
                <td>
                  <ShiftList2
                    id_c={company.id_c}
                    value={idShift}
                    onSelect={(v) => setIdShift(v)}
                  />
                </td>
              </tr>

              {/* 👇 NUEVO: Operador */}
              <tr>
                <td><label>{t("operator1") || "Operador (id_operator)"}</label></td>
                <td>
                  <OperatorList2
                    id_c={company.id_c}
                    value={idOperator}
                    onSelect={(v) => setIdOperator(v)}
                  />
                </td>
              </tr>

                            <tr>

                                <td><label htmlFor="cod_producto">{t("batchList3")}</label></td>
                                <td>

                                    <ProdListBut
                                        id_c={company.id_c}
                                        onSelect={(value) => setIdProd(value)}

                                    />
                                </td>

                            </tr>
                            <tr>

                                <td><label htmlFor="cod_model">{t("batchList27")}</label></td>
                                <td>

                                    <ModelListBut
                                        id_c={company.id_c}
                                        id_prod={idProd}
                                        onSelect={(value) => setModel(value)}

                                    />
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="cod_maquina">{t("batchList2")}</label></td>
                                <td>
                                    <MachinesList3
                                        id_c={company.id_c}
                                        id_prod={idProd}
                                        onSelect={(value) => setCodMaq(value)}
                                    />
                                </td>
                            </tr>




                            <tr>


                                <td><label htmlFor="fecha_ini">{t("batchList7")}</label></td>
                                <td>
                                    <DatePicker
                                        selected={fechaIni}
                                        onChange={(date) => setfechaIni(date)}
                                        dateFormat="yyyy-MM-dd"
                                        locale={es}
                                        placeholderText="AAAA-MM-DD"
                                        className="input1"
                                        id="fecha_ini"
                                        name="fecha_ini"
                                        required
                                    />

                                </td>
                            </tr>




                            <tr>
                                <td><label htmlFor="time_ini">{t("batchList8")}</label>
                                </td>
                                <td>
                                    <DatePicker
                                        selected={timeIni}
                                        onChange={(date) => setTimeIni(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={5} // puedes cambiar a 5 o 60
                                        timeCaption="Hora"
                                        dateFormat="HH:mm"
                                        timeFormat="HH:mm"
                                        locale={es}
                                        placeholderText="Selecciona hora"
                                        className="input1"
                                        id="time_ini"
                                        name="time_ini"
                                        required
                                    />
                                </td>
                            </tr>




                            <tr>
                                <td><label htmlFor="time_fin">{t("batchList10")}</label>
                                </td>
                                <td>
                                    <DatePicker
                                        selected={timeFin}
                                        onChange={(date) => setTimeFin(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={5} // puedes cambiar a 5 o 60
                                        timeCaption="Hora"
                                        dateFormat="HH:mm"
                                        timeFormat="HH:mm"
                                        locale={es}
                                        placeholderText="Selecciona hora"
                                        className="input1"
                                        id="time_fin"
                                        name="time_fin"
                                        required
                                    />
                                </td>
                            </tr>




                            <tr>
                                <td><label htmlFor="und_OK">{t("batchList5")}</label></td>
                                <td>
                                    <input
                                        className="input1"
                                        type="number"
                                        value={undOK}
                                        onChange={(e) => setUndOK(e.target.value)}
                                        id="und_OK"
                                        name="und_OK"
                                        min="0"
                                        required
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td><label htmlFor="und_NC">{t("batchList6")}</label></td>
                                <td>
                                    <input
                                        className="input1"
                                        type="number"
                                        value={undNC}
                                        onChange={(e) => setUndNC(e.target.value)}
                                        id="und_NC"
                                        name="und_NC"
                                        min="0"
                                        required
                                    />
                                </td>
                            </tr>




                        </tbody>
                    </table>

                    <button type="submit" className="button7">{t("prodList12")}</button>
                    <button
                        type="button"
                        className="button7"
                        onClick={handleGoBack}


                    >
                        {t("prodList13")}
                    </button>
                </form>
                
                
                {/*<ChatReg1/>
                Chat para diligenciamiento de lote
                */}


            </div>
        </div>
    );
};


export default NewBatchForm;
